import { debounce, xorWith } from 'lodash-es';
import Siema from 'siema';
import Headroom from 'headroom.js';
import Cookies from 'js-cookie';
import langPopup from './langPopup.json';

export const isElementChildOf = (element, query, maxDeepness = 10) => {
    if (!element || maxDeepness < 0)
        return false;
    else
        return element.matches(query) || isElementChildOf(element.parentElement, query, maxDeepness - 1);
};


export const onChangeLanguage = event => {
    const nextPathname = event.target.value;
    Cookies.set('lang', event.target.querySelector(`[value="${nextPathname}"]`).dataset.lang, { expires: 90 });
    const hash = window.location.hash;
    window.location.href = `${nextPathname}${hash}`;
};

export const listenChangeLanguage = () => {
    const footerLanguage = document.querySelector('#FooterLanguage');
    if (footerLanguage)
        footerLanguage.addEventListener('change', onChangeLanguage);
};

export const stopListenChangeLanguage = () => {
    const footerLanguage = document.querySelector('#FooterLanguage');
    if (footerLanguage)
        footerLanguage.removeEventListener('change', onChangeLanguage);
};


//tofix: test on ie11
export const existsQueryParam = param => {
    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    return !!params[param];
};

export const getQueryParam = param => {
    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    return params[param];
};

const onSiemaSliderChange = function () {
    const siemaButtons = this.selector.getElementsByTagName('button');
    const counter = this.currentSlide;
    const slides = document.querySelectorAll('.slider > div > div');
    const slidewrap = document.querySelector('.slider > div');
    if (slidewrap) {
        slidewrap.style.height = slides[counter + 1].offsetHeight + 'px';
    }

    Array.prototype.forEach.call(siemaButtons, (siemaButton, index) => {
        if (index === this.currentSlide) {
            siemaButtons[index].classList.add('active');
        } else {
            siemaButtons[index].classList.remove('active');
        }
    });
};

export const initSliders = () => {
    const sliderElements = document.getElementsByClassName('slider');

    if (sliderElements.length > 0) {
        const sliders = new Siema({
            selector: '.slider',
            duration: 250,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: true,
            multipleDrag: false,
            threshold: 20,
            loop: true,
            rtl: false,
            onChange: onSiemaSliderChange
        });

        const slides = document.querySelectorAll('.slider > div > div');
        const slidewrap = document.querySelector('.slider > div');
        let slidedrag = false;
        if (slidewrap) {
            slidewrap.style.height = slides[1].offsetHeight + 'px';
            slidewrap.addEventListener('mousedown', () => { slidedrag = false; } );
            slidewrap.addEventListener('mousemove', () => { slidedrag = true; } );
            slidewrap.addEventListener('mouseup', () => { if (!slidedrag) { sliders.next(); } } );
        }

        Siema.prototype.addPagination = function () {
            Array.prototype.forEach.call(this.innerElements, (innerElement, index) => {
                const siemaPaginationButton = document.createElement('button');
                siemaPaginationButton.textContent = `${index}`;
                siemaPaginationButton.addEventListener('click', () => { this.goTo(index); });
                if (index === 0)
                    siemaPaginationButton.classList.add('active');
                this.selector.appendChild(siemaPaginationButton);
            });
        };

        sliders.addPagination();

        const addPagination = function () {
            sliders.addPagination();
        };

        window.addEventListener('resize', debounce(addPagination, 250));
    }
};

export const initAccordion = () => {
    const accordionElements = document.getElementsByClassName('accordion__title');
    const accordionClass = 'accordion__title--collapsed';

    const collapseSection = element => {
        const sectionHeight = element.scrollHeight;
        const elementTransition = element.style.transition;
        element.style.transition = '';
        requestAnimationFrame(() => {
            element.style.height = sectionHeight + 'px';
            element.style.transition = elementTransition;
            requestAnimationFrame(() => element.style.height = 0 + 'px');
        });
        element.previousElementSibling.classList.add(accordionClass);
    };

    const expandSection = element => {
        const sectionHeight = element.scrollHeight;
        element.style.height = sectionHeight + 'px';
        element.addEventListener('transitionend', function tEnd () {
            element.removeEventListener('transitionend', tEnd);
            element.style.height = null;
        });
        element.previousElementSibling.classList.remove(accordionClass);
    };

    Array.prototype.forEach.call(accordionElements, function (el) {
        el.addEventListener('click', function () {
            const section = el.nextElementSibling;
            if (el.classList.contains(accordionClass)) {
                expandSection(section);
                el.classList.remove(accordionClass);
            } else {
                collapseSection(section);
            }
        });
    });
};

export const simpleModal = (title = '', message = '', icon = '', isError = false) => {
    let text = '';
    const responsetime = document.querySelector('.headliner h5');

    if (icon)
        text = '<i class="icon icon--modal icon--'+icon+'"></i>';

    if (title)
        text = text + '<h4>' + title + '</h4>';

    if (!isError && responsetime)
        text = text + responsetime.textContent + ' ';

    if (message)
        text = text + message;

    const modal = '<div class="modal modal--small modal--flash"><div class="modal__body"><div class="modal__content"><div class="icon modal__header-close--always-visible"></div>'+text+'</div></div></div>';

    document.querySelector('body').classList.add('is-modal-visible');
    document.querySelector('body').insertAdjacentHTML('beforeend', modal);
    document.querySelector('.modal--flash').addEventListener('click', function (el) {
        el.preventDefault();
        const modal = document.querySelector('.modal--flash');
        modal.parentNode.removeChild(modal);
        document.querySelector('body').classList.remove('is-modal-visible');
    });
};

export let snackbarTimer;

export const showSnackbar = (message, kind) => {
    clearTimeout(snackbarTimer);

    const snackbarDomElement = document.querySelector('#snackbar');
    const snackbarCopyDomElement = document.querySelector('#snackbar .snackbar__copy');
    const snackbarCloseWrapperDomElement = document.querySelector('#snackbar .snackbar__close-wrapper');

    if (snackbarDomElement && snackbarCopyDomElement && snackbarCloseWrapperDomElement) {
        snackbarCopyDomElement.innerHTML = message;
        snackbarCloseWrapperDomElement.addEventListener('click', hideSnackbar);
        snackbarTimer = setTimeout(hideSnackbar, 10 * 1000);
        snackbarDomElement.className = `snackbar snackbar--visible snackbar--${kind}`;
    }
};

export const hideSnackbar = () => {
    clearTimeout(snackbarTimer);

    const snackbarDomElement = document.querySelector('#snackbar');
    const snackbarCopyDomElement = document.querySelector('#snackbar .snackbar__copy');
    const snackbarCloseWrapperDomElement = document.querySelector('#snackbar .snackbar__close-wrapper');

    if (snackbarDomElement && snackbarCopyDomElement && snackbarCloseWrapperDomElement) {
        snackbarDomElement.className = 'snackbar';
        snackbarCopyDomElement.innerText = '';
        snackbarCloseWrapperDomElement.removeEventListener('click', hideSnackbar);
    }
};

export const toggleHeader = () => {
    const header = document.querySelector('header');
    const hamburger = document.querySelector('#input-hamburger');



    if (header && hamburger) {
        hamburger.addEventListener('change', function () {
            if (this.checked)
                header.classList.add('header--menu-open');
            else
                header.classList.remove('header--menu-open');
        }, false);

        const headroom = new Headroom(header, {
            offset: 100,
            tolerance: {
                up: 5,
                down: 0
            },
            classes: {
                initial: 'header',
                pinned: 'header--pinned',
                unpinned: 'header--unpinned',
                top: 'header--top',
                notTop: 'header--not-top',
                bottom: 'header--bottom',
                notBottom: 'header--not-bottom'
            }
        });


        headroom.init();
    }
};

export const mobileResizeUpdateModalContentHeight = () => {
    if (window.innerWidth <= 768) {
        const modalContent = document.querySelector('.modal .modal__body .modal__content');

        if (modalContent) {
            const modalContentHeight = window.innerHeight - 112;
            modalContent.style = `height: ${modalContentHeight}px;`;
        }
    }
};

const debouncedMobileResizeUpdateModalContentHeight = debounce(mobileResizeUpdateModalContentHeight, 250);

export const startMobileListenResizeForUpdateModalContentHeight = () => window.addEventListener('resize', debouncedMobileResizeUpdateModalContentHeight);

export const stopMobileListenResizeForUpdateModalContentHeight = () => window.addEventListener('resize', debouncedMobileResizeUpdateModalContentHeight);

export const tableToggle = () => {
    const tabletoggleElements = document.querySelectorAll('table.advanced tr[id]');
    const tabletoggleClass = 'expanded';

    Array.prototype.forEach.call(tabletoggleElements, el => {
        el.addEventListener('click', () => {
            if (el.classList.contains(tabletoggleClass))
                el.classList.remove(tabletoggleClass);
            else
                el.classList.add(tabletoggleClass);
        });
    });
};

export const tabToggle = () => {
    const tabtoggleElements = document.querySelectorAll('a.tab-link');
    const tabtoggleClass = 'tab-link--active';
    const tabClass = 'tab--active';

    Array.prototype.forEach.call(tabtoggleElements, el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            const link = el.getAttribute('href').replace('#', '');
            el.classList.add(tabtoggleClass);
            
            Array.prototype.forEach.call(el.parentNode.children, child => {
                if (child !== el) {
                    if (child.classList.contains('tab-link')) {
                        child.classList.remove(tabtoggleClass);
                    }
                    if (child.classList.contains('tab')) {
                        if (child.getAttribute('id') === link) {
                            child.classList.add(tabClass);
                        } else {
                            child.classList.remove(tabClass);
                        }
                    }
                }
            });
            
            if(el.parentNode.classList.contains('tab-wrap')) {
              Array.prototype.forEach.call(el.parentNode.parentNode.children, child => {
                  if (child !== el) {
                      if (child.classList.contains('tab')) {
                          if (child.getAttribute('id') === link) {
                              child.classList.add(tabClass);
                          } else {
                              child.classList.remove(tabClass);
                          }
                      }
                  }
              });
            }
        
        });
    });
};

export const updateCustomersCountDomElements = customers => document.querySelectorAll('[data-customers-count]').forEach(element => element.innerHTML = customers);

export const updateTranslatorsCountDomElements = translators => document.querySelectorAll('[data-translators-count]').forEach(element => element.innerHTML = translators);

export const updateLanguagesCountDomElements = languages => document.querySelectorAll('[data-languages-count]').forEach(element => element.innerHTML = languages);

export const updateDataPhoneDomElements = phone => document.querySelectorAll('[data-phone-number]').forEach(element => {
    element.href = 'tel:' + phone;
    element.innerHTML = phone;
});

export const updateDataCallNowDomElements = (message, isOpen, messageOtherNumbers, messageAfterStatus) => {
    document.querySelectorAll('[data-call-now]').forEach(element => {
        element.innerHTML = message;
        element.className = isOpen ? 'call-now__status call-now__status--active' : 'call-now__status';
    });

    document.querySelectorAll('[data-call-now-additional-msg]').forEach(element => element.innerHTML = messageAfterStatus);

    document.querySelectorAll('[data-phone-country]').forEach(element => element.innerHTML = messageOtherNumbers);
};


export const removeTableLimit = () => {
    const tableLimitToggles = document.querySelectorAll('a.remove-table-limit');
    Array.prototype.forEach.call(tableLimitToggles, el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            el.closest('table').classList.remove('first-10');
            el.parentNode.removeChild(el);
        });
    });
};

// tofix: refactor this
export const languageBanner = defaultlang => {   
    let cookieLang = '';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf('bannerlang=') == 0) {
            cookieLang = c.substring('bannerlang='.length, c.length);
        }
    }

    if (!cookieLang) {
        let userLang = navigator.language || navigator.userLanguage;
        userLang = userLang.slice(0, 2);
        if (typeof langPopup[userLang] === 'undefined') {
            userLang = defaultlang;
        }
        const switchNode = document.querySelectorAll('#FooterLanguage option[data-lang="'+userLang+'"]:not([selected])');
        if (switchNode.length) {
            const switchLink = switchNode[0].getAttribute('value');
            document.querySelectorAll('body > footer')[0].insertAdjacentHTML('beforeend', '<aside class="language-redirect language-redirect--'+userLang+'"><a href="#">&times;</a><h6>'+langPopup[userLang][0]+'</h6><a href="'+switchLink+'" class="link">'+langPopup[userLang][1]+'</a> <a href="#">'+langPopup[userLang][2]+'</a></aside>');

            [].forEach.call(document.querySelectorAll('aside a'), function (el) {
                el.addEventListener('click', function (el) {
                    if (el.currentTarget.href.includes('#')) {
                        el.preventDefault();
                        const d = new Date();
                        d.setTime(d.getTime() + (5184000000));
                        const expires = 'expires='+d.toUTCString();
                        document.cookie = 'bannerlang=' + userLang + ';' + expires + ';path=/';
                        document.querySelectorAll('aside.language-redirect')[0].style.display = 'none';
                    }
                });
            });
        }
    }
};

